import React from "react";
import "./About.css";
import FadeInSection from "../../Hooks/FadeInSection";

export default function About() {
  return (
    <FadeInSection>
      <div className="about-me-container visible">
        <div className="about-me-header slide-in-right">
          <h3>the journey..</h3>
        </div>
        <div className="about-me-content slide-in-left">
          <p>
            At 13, I was charging friends $30 to trick out their MySpace layouts. I
            didn’t know it then, but I had just written my first line of code and
            accidentally started my tech career. Still, I thought I was destined for
            the business world. So I climbed the retail ladder, became a regional
            general manager, and ran multi-million dollar stores while secretly
            moonlighting as a web dev for fun.
            <br />
            <br />
            Eventually, I stopped ignoring the obvious. I took the leap, enrolled in
            General Assembly’s software engineering bootcamp with a toddler in one
            arm and another baby on the way, and fully switched careers. It was
            risky, chaotic, and easily the best decision I’ve ever made.
            <br />
            <br />
            Now I’m a full stack engineer with over five years of experience
            building scalable, user-first web applications for industries like
            healthcare, education, and telecom. I've led projects that improved
            performance by 80 percent, streamlined releases, and helped bring in
            over $1.6 billion in revenue. I specialize in React, Next.js,
            TypeScript, performance tuning, and turning complex systems into clean,
            elegant code.
            <br />
            <br />
            I build things that are fast, accessible, and easy to fall in love with.
            Whether I’m designing UI workflows or deep in server-side logic, I’m all
            about clean code, smart architecture, and shipping work that actually
            matters.
            <br />
            <br />
            When I’m not coding, I’m throwing rooftop events, mentoring new
            engineers, or reorganizing my Figma files for fun.
            <br />
            <br />
            Let’s make the internet better, one component at a time.
          </p>
        </div>
      </div>
    </FadeInSection>
  );
}
